import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { ComparisonTable } from 'ui/src/components/ComparisonTable/ComparisonTable'

// The way Storyblok returns checked and empty cells
const TableMarkers = {
  Covered: '[*]',
  NotCovered: '[]',
} as const

export const useFormatComparisonValue = () => {
  const { t } = useTranslation()
  return useCallback(
    (value: string | boolean) => {
      if (value === true || value === TableMarkers.Covered) {
        return <ComparisonTable.CoveredIcon aria-label={t('COVERED')} />
      } else if (value === false || value === TableMarkers.NotCovered) {
        return <ComparisonTable.NotCoveredIcon aria-label={t('NOT_COVERED')} />
      } else {
        return value
      }
    },
    [t],
  )
}
